import React, { useEffect } from 'react';
import { Grid, Typography, Link, Box, IconButton } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import ImageList from '@mui/material/ImageList';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { Facebook, Instagram, Language } from '@mui/icons-material';
import VendorButton from '../../../../../components/Messenger/ChatButton/VendorButton';
import {
  Layout,
  Loading,
  UserNavbar,
  TranslucentContainer,
  ReturnButton,
} from '../../../../../components';
import * as UserActions from '../../../../../core/users/action';
import AssetPhotoListProfile from './AssetPhotoListProfile';

export default function VendorPublicProfile() {
  const { loading, vendorUser } = useSelector((store) => store.users);
  const { vendorId: userId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(UserActions.getUserById(userId));
  }, []);

  const validateUrl = (url) => {
    const regex = /^(https?|http):\/\//i;
    return regex.test(url);
  };
  return (
    <Layout>
      <UserNavbar />
      {loading ? (
        <Loading />
      ) : (
        <Grid container justifyContent="center" textAlign="center" pt={10}>
          <Grid
            item
            xs={12}
            md={12}
            marginLeft={{ md: 18 }}
            justifyContent="left"
            sx={{ display: 'flex' }}>
            <ReturnButton />
          </Grid>
          <TranslucentContainer>
            <Grid container spacing={2} marginTop={2}>
              <Grid item xs={12} textAlign="left">
                <Typography component="div" variant="h5" textAlign="left" marginBottom="1rem">
                  Welcome,{' '}
                  {vendorUser?.vendor_company_name
                    ? vendorUser?.vendor_company_name
                    : 'Company name not provided'}
                  !
                </Typography>
                <Grid item xs={12} display="flex" flexDirection="row" gap="1rem" mb="1rem">
                  {vendorUser.vendor_social_network?.length > 0 ? (
                    <>
                      {vendorUser.vendor_social_network.find(
                        (item) => item.name === 'Facebook' && !!item.url,
                      ) != null ? (
                        <Link
                          href={
                            vendorUser.vendor_social_network.find(
                              (item) => item.name === 'Facebook',
                            )?.url
                          }
                          target="_blank"
                          display="flex"
                          title="Open Facebook site"
                          alignItems="center">
                          <Facebook sx={{ color: '#FD9D7E' }} />
                        </Link>
                      ) : null}
                      {vendorUser.vendor_social_network.find(
                        (item) => item.name === 'Instagram' && !!item.url,
                      ) != null ? (
                        <Link
                          href={
                            vendorUser.vendor_social_network.find(
                              (item) => item.name === 'Instagram',
                            )?.url
                          }
                          underline="none"
                          target="_blank"
                          display="flex"
                          title="Open Instagram site"
                          alignItems="center">
                          <Instagram sx={{ color: '#FD9D7E' }} />
                        </Link>
                      ) : null}
                    </>
                  ) : null}
                  {vendorUser.web_site && (
                    <Link
                      href={
                        validateUrl(vendorUser.web_site)
                          ? vendorUser.web_site
                          : `https://${vendorUser.web_site}`
                      }
                      underline="none"
                      target="_blank"
                      display="flex"
                      title="Open Website"
                      alignItems="center">
                      <Language sx={{ color: '#FD9D7E' }} />
                    </Link>
                  )}
                </Grid>
                <Typography variant="subtitle1">My business</Typography>
                <Typography variant="body2" marginBottom="0.5rem" textAlign="justify">
                  {vendorUser?.vendor_business_desc
                    ? vendorUser?.vendor_business_desc
                    : 'Description not provided'}
                </Typography>
                <Typography variant="subtitle1">About my products</Typography>
                <Typography variant="body2" marginBottom="0.5rem" textAlign="justify">
                  {vendorUser?.vendor_product_desc
                    ? vendorUser?.vendor_product_desc
                    : 'Description not provided'}
                </Typography>
                <Typography variant="subtitle1">Category</Typography>
                <Grid xs={12} sx={{ display: 'flex', mt: 1 }}>
                  {vendorUser?.user_tags &&
                    vendorUser?.user_tags.map((userTag) => (
                      <Box
                        key={userTag?.fk_category}
                        sx={{
                          borderRadius: '17px',
                          backgroundColor: '#0997BA',
                          py: 1,
                          px: 2,
                          color: 'white',
                          justifyContent: 'center',
                          mr: 1,
                        }}>
                        {userTag?.category?.name}
                      </Box>
                    ))}
                </Grid>
              </Grid>

              {loading ? (
                <Grid container>
                  <Stack spacing={1} p={3}>
                    <Skeleton variant="rectangular" width={200} height={180} />
                    <Skeleton variant="circular" width={40} height={40} />
                  </Stack>
                  <Stack spacing={1} p={3}>
                    <Skeleton variant="rectangular" width={150} height={180} />
                    <Skeleton variant="circular" width={40} height={40} />
                  </Stack>
                  <Stack spacing={1} p={3}>
                    <Skeleton variant="rectangular" width={150} height={180} />
                    <Skeleton variant="circular" width={40} height={40} />
                  </Stack>
                  <Stack spacing={1} p={3}>
                    <Skeleton variant="rectangular" width={150} height={180} />
                    <Skeleton variant="circular" width={40} height={40} />
                  </Stack>
                  <Stack spacing={1} p={3}>
                    <Skeleton variant="rectangular" width={150} height={180} />
                    <Skeleton variant="circular" width={40} height={40} />
                  </Stack>
                  <Stack spacing={1} p={3}>
                    <Skeleton variant="rectangular" width={200} height={180} />
                    <Skeleton variant="circular" width={40} height={40} />
                  </Stack>
                </Grid>
              ) : (
                <Grid container>
                  <ImageList ariant="masonry" cols={5} gap={8} sx={{ padding: 3 }}>
                    {vendorUser?.assets?.map((item) => (
                      <AssetPhotoListProfile key={item.id} asset={item} />
                    ))}
                  </ImageList>
                </Grid>
              )}
              <VendorButton vendor={vendorUser} />
            </Grid>
          </TranslucentContainer>
        </Grid>
      )}
    </Layout>
  );
}
